/**
 * #1854 — fire-and-forget prewarm of the assign caches.
 *
 * ed: "can we get a jump on the cache, when we select a job, or enter a call
 * sheet, or phone sheet, can we start loading skills and bookings?"
 *
 * THE RULE THIS FILE EXISTS TO KEEP: it must never delay the page that fires it.
 *
 *  - Never awaited. Callers invoke it and move on; the return value is ignored.
 *  - Scheduled after the current work, via requestIdleCallback where the browser
 *    has it and a 0 ms timeout otherwise, so it cannot contend with the render
 *    or the fetches the page is already doing.
 *  - Every failure is swallowed. A warm that does not happen costs a slower
 *    first grid load; it must never cost an error on screen.
 *  - De-duplicated per id for the life of the page, so re-entering the same job
 *    does not re-fire. The server holds its own short lock as well, because
 *    several dispatchers can open the same job.
 */
import service from './services.js';

const alreadyWarmed = new Set();

function schedule(fn) {
    if (typeof window !== 'undefined' && typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(fn, { timeout: 2000 });
    } else {
        setTimeout(fn, 0);
    }
}

function warm(kind, id, headers) {
    if (!id) return;

    const key = kind + ':' + id;
    if (alreadyWarmed.has(key)) return;
    alreadyWarmed.add(key);

    schedule(() => {
        try {
            service.post(kind + '/' + id + '/warmAssignCache', {}, headers).catch(() => {});
        } catch (e) {
            /* never surfaces to the page */
        }
    });
}

/** Call on job selection. */
export function warmJobCache(jobId, headers) {
    warm('job', jobId, headers);
}

/** Call on call sheet / phone sheet entry — warms that call's whole job. */
export function warmCallCache(callId, headers) {
    warm('call', callId, headers);
}

export default { warmJobCache, warmCallCache };
